<div class="row">
  <div
  [ngClass]="{ 'col-md-8 offset-md-2 col-lg-6 offset-lg-3': !templateForPermitForm }"
>
    <div class="mt-5 mx-auto">
      <div class="card"
      >
        <div class="card-body">
          <h5 class="card-title">Register New User</h5>

          <app-loader *ngIf="loading"></app-loader>

          <form
            (submit)="save()"
            #registerForm="ngForm"
            [formGroup]="form"
            novalidate
            *ngIf="
              !registrationCompleted &&
              !invitedEmailHasUser &&
              !loading &&
              !templateForPermitForm
            "
          >
            <div
              class="form-group"
              [class.is-invalid]="fullName.hasError('required')"
            >
              <label for="fullName" class="bmd-label-static"
                >Full Name <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control field"
                [(ngModel)]="user.name"
                [formControl]="fullName"
                name="fullName"
              />
              <wm-control-message
                [controlName]="'fullName'"
              ></wm-control-message>
              <!--<div *ngIf="fullName.hasError('required') && fullName.touched" class="text-danger">
              Full Name is required
          </div>-->
            </div>

            <div
              class="form-group"
              [class.is-invalid]="userName.hasError('required')"
            >
              <label for="userName" class="bmd-label-static"
                >User Name <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="user.userName"
                [formControl]="userName"
                name="userName"
              />
              <wm-control-message
                [controlName]="'userName'"
              ></wm-control-message>
              <!--<div *ngIf="userName.hasError('required') && userName.touched" class="text-danger">
              Username is required
          </div>-->
            </div>

            <div
              class="form-group"
              [class.is-invalid]="password.hasError('required')"
              *ngIf="showPasswordInput"
            >
              <label for="password" class="bmd-label-static"
                >Password <span class="text-danger">*</span></label
              >
              <input
                type="password"
                class="form-control"
                [(ngModel)]="user.password"
                [formControl]="password"
                name="password"
              />
              <wm-control-message
                [controlName]="'password'"
              ></wm-control-message>
              <!--<div *ngIf="password.hasError('required') && password.touched" class="text-danger">
              Password is required
          </div>-->
            </div>

            <div
              class="form-group"
              [class.is-invalid]="
                confirmPasswordCtl.hasError('required') ||
                form.hasError('mismatchedPasswords')
              "
              *ngIf="showPasswordInput"
            >
              <label for="confirmPassword" class="bmd-label-static"
                >Confirm Password <span class="text-danger">*</span></label
              >
              <input
                type="password"
                class="form-control"
                [(ngModel)]="user.confirmPassword"
                [formControl]="confirmPasswordCtl"
                name="confirmPassword"
              />
              <wm-control-message
                [controlName]="'confirmPassword'"
              ></wm-control-message>
              <!--<div *ngIf="confirmPasswordCtl.hasError('required') && confirmPasswordCtl.touched" class="text-danger">
              Confirm Password is required
          </div>-->
              <div
                *ngIf="
                  form.hasError('mismatchedPasswords') &&
                  confirmPasswordCtl.touched
                "
                class="text-danger"
              >
                Passwords do not match
              </div>
            </div>

            <div
              class="form-group"
              [class.is-invalid]="
                emailAddress.hasError('required') || form.hasError('required')
              "
            >
              <label for="email" class="bmd-label-static"
                >Email Address <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="user.emailAddress"
                [formControl]="emailAddress"
                name="email"
              />
              <wm-control-message
                [controlName]="'emailAddress'"
              ></wm-control-message>
              <div
                *ngIf="
                  emailAddress.hasError('required') && emailAddress.touched
                "
                class="text-danger"
              >
                Email Address is required
              </div>
            </div>

            <div class="form-group">
              <wm-address-detail
                [address]="user.address"
                [showButtons]="false"
                [required]="false"
                [showName]="false"
              ></wm-address-detail>
            </div>

            <div class="form-group">
              <label for="phoneNumber" class="bmd-label-static"
                >Phone Number</label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="user.phoneNumber"
                [formControl]="phoneNumber"
                name="phoneNumber"
              />
            </div>

            <div class="mt-5">
              <button class="btn btn-default" (click)="cancel()">
                Cancel
              </button>
              <button
                class="btn btn-raised btn-primary"
                [disabled]="!registerForm.valid || saving"
              >
                <span *ngIf="!saving">Register</span>

                <span *ngIf="saving">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Registering...
                </span>
              </button>
            </div>
          </form>
<!-- added by priya 03-12-2025
 -->
          <form
            (submit)="save()"
            #registerForm="ngForm"
            [formGroup]="form"
            novalidate
            *ngIf="
              !registrationCompleted &&
              !invitedEmailHasUser &&
              !loading &&
              templateForPermitForm
            "
          >
            <div
              class="form-group"
              [ngClass]="{ 'form-content': templateForPermitForm }"
              [class.is-invalid]="
                fullName.touched && fullName.hasError('required')
              "
            >
              <wm-common-textfield
                [data]="{
                label: 'Full Name',
                required: true,
                helperText: fullName.touched && fullName.hasError('required')? 'Full Name is Required':'',
                value:user.name
              }"
                              [formControl]="fullName"
                              (valueChange)="user.name = $event"

              ></wm-common-textfield>
              <!-- <ng-template #controlMessageTemplate>
                <wm-control-message
                  [controlName]="'fullName'"
                ></wm-control-message>
              </ng-template> -->
            </div>

            <div
              class="form-group"
              [ngClass]="{ 'form-content': templateForPermitForm }"

              [class.is-invalid]="userName.hasError('required')"
            >
              <!-- <label for="userName" class="bmd-label-static"
                >User Name <span class="text-danger">*</span></label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="user.userName"
                [formControl]="userName"
                name="userName"
              />
              <wm-control-message
                [controlName]="'userName'"
              ></wm-control-message> -->
              <!--<div *ngIf="userName.hasError('required') && userName.touched" class="text-danger">
              Username is required
          </div>-->

              <wm-common-textfield
                [data]="{
            label: 'User Name',
            required: true,
            helperText: userName.touched && userName.hasError('required')? 'User Name is Required':'',
            value:user.userName
          }"
                          [formControl]="userName"
                          (valueChange)="user.userName = $event"

              ></wm-common-textfield>
              <!-- <ng-template #userMessageTemplate>
                <wm-control-message
                  [controlName]="'userName'"
                ></wm-control-message>
              </ng-template> -->
            </div>

            <div
              class="form-group"
              [ngClass]="{ 'form-content': templateForPermitForm }"

              [class.is-invalid]="password.hasError('required')"
              *ngIf="showPasswordInput"
            >
              <!-- <label for="password" class="bmd-label-static"
                >Password <span class="text-danger">*</span></label
              >
              <input
                type="password"
                class="form-control"
                [(ngModel)]="user.password"
                [formControl]="password"
                name="password"
              />
              <wm-control-message
                [controlName]="'password'"
              ></wm-control-message> -->
              <!--<div *ngIf="password.hasError('required') && password.touched" class="text-danger">
              Password is required
          </div>-->
              <wm-common-textfield
                [data]="{
            label: 'Password',
            required: true,
            helperText: password.touched && password.hasError('required')? 'Password is Required':'',
            value:user.password

          }"
                          [formControl]="password"
                          (valueChange)="user.password = $event"

              ></wm-common-textfield>
              <!-- <ng-template #passwordMessageTemplate>
                <wm-control-message
                  [controlName]="'password'"
                ></wm-control-message>
              </ng-template> -->
            </div>

            <div
              class="form-group"
              [ngClass]="{ 'form-content': templateForPermitForm }"

              [class.is-invalid]="
                confirmPasswordCtl.hasError('required') ||
                form.hasError('mismatchedPasswords')
              "
              *ngIf="showPasswordInput"
            >
              <!-- <label for="confirmPassword" class="bmd-label-static"
                >Confirm Password <span class="text-danger">*</span></label
              >
              <input
                type="password"
                class="form-control"
                [(ngModel)]="user.confirmPassword"
                [formControl]="confirmPasswordCtl"
                name="confirmPassword"
              />
              <wm-control-message
                [controlName]="'confirmPassword'"
              ></wm-control-message> -->
              <!--<div *ngIf="confirmPasswordCtl.hasError('required') && confirmPasswordCtl.touched" class="text-danger">
              Confirm Password is required
          </div>-->
              <!-- <div
                *ngIf="
                  form.hasError('mismatchedPasswords') &&
                  confirmPasswordCtl.touched
                "
                class="text-danger"
              >
                Passwords do not match
              </div> -->
              <!-- <wm-common-textfield
                [data]="{
                label: 'Confirm Password',
                required: true,
                value: user.confirmPassword,
                onChange: onFieldChange.bind(this, 'confirmPassword'),
                helperText: confirmPasswordMessageTemplate
              }"
              ></wm-common-textfield>
              <ng-template #confirmPasswordMessageTemplate>
                <wm-control-message
                  [controlName]="'confirmPassword'"
                ></wm-control-message>
                <div
                  *ngIf="
                    form.hasError('mismatchedPasswords') &&
                    confirmPasswordCtl.touched
                  "                                                                                
                  class="text-danger"
                >
                  Passwords do not match
                </div>
              </ng-template> -->
              <wm-common-textfield
              [data]="{
          label: 'Confirm Password *',
          helperText:
  confirmPasswordCtl.touched && form.hasError('mismatchedPasswords')
    ? 'Passwords do not match'
    : confirmPasswordCtl.touched && confirmPasswordCtl.hasError('required')
    ? 'Password is required'
    : '',
    value:user.confirmPassword
        }"
                [formControl]="confirmPasswordCtl"
                (valueChange)="user.confirmPassword = $event"

            ></wm-common-textfield>
            </div>

            <!-- <div class="form-group">
              <ng-template #emailHelper>
                <wm-control-message [controlName]="'emailAddress'"></wm-control-message>
                <div class="text-danger" *ngIf="emailAddress.touched && emailAddress.hasError('required')">
                  Email Address is required
                </div>
              </ng-template>
            
              <wm-common-textfield
                [data]="{
                  label: 'Email Address *',
                  value: user.emailAddress,
                  onChange: onFieldChangeForEmail,
                  helperText: emailHelper
                }"
              ></wm-common-textfield>
            </div> -->

            <div
              class="form-group"
              [ngClass]="{ 'form-content': templateForPermitForm }"

              [class.is-invalid]="
                emailAddress.hasError('required') || form.hasError('required')
              "
            >
              <wm-common-textfield
                [data]="{
                  label: 'Email Address',
                  type: 'text',
                  required: true,
                  helperText: emailAddress.touched && emailAddress.hasError('required')?'Email Address is required':'',
value:user.emailAddress
                }"
                [formControl]="emailAddress"
                (valueChange)="user.emailAddress = $event"

              ></wm-common-textfield>

              <!-- <ng-template #emailHelper>
                <wm-control-message
                  [controlName]="'emailAddress'"
                ></wm-control-message>
                <div
                  class="text-danger"
                  *ngIf="
                    emailAddress.touched && emailAddress.hasError('required')
                  "
                >
                  Email Address is required
                </div>
              </ng-template> -->
            </div>

            <div class="form-group"            
            >
              <wm-address-detail
                [address]="user.address"
                [showButtons]="false"
                [required]="false"
                [showName]="false"
              ></wm-address-detail>
            </div>

            <div class="form-group"    [ngClass]="{ 'form-content': templateForPermitForm }">
              <!-- <label for="phoneNumber" class="bmd-label-static"
                >Phone Number</label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="user.phoneNumber"
                [formControl]="phoneNumber"
                name="phoneNumber"
              /> -->
              <wm-common-textfield
                [data]="{
                  label: 'Phone Number',
                  type: 'text',
value:user.phoneNumber
                }"
                                [formControl]="phoneNumber"
                                (valueChange)="user.phoneNumber = $event"

              ></wm-common-textfield>
            </div>

            <div class="button-container">
              <!-- <button class="btn btn-default" (click)="cancel()">
                Cancel
              </button> -->
              <wm-common-button
              class="cancel-button"
              [data]="{text:'Cancel',onClick:     cancel.bind(this)}"

              >
                
              </wm-common-button>
              <!-- <button
                class="btn btn-raised btn-primary"
                [disabled]="!registerForm.valid || saving"
              >
                <span *ngIf="!saving">Register</span>

                <span *ngIf="saving">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Registering...
                </span>
              </button> -->
              <wm-common-button
              class="register-button"
              [data]="{
                text: saving ? 'Registering...' : 'Register',
                disabled: !form.valid || saving,
                loading: saving,
                onClick: save.bind(this)
              }"
            ></wm-common-button>
            
            </div>
          </form>
<!-- end by priya 03-12-2025
 -->

          <div *ngIf="registrationCompleted && !invitation">
            <h6>
              Account Verification
            </h6>
            <p>
              An email has been sent to the address you provided. Please click
              on the link included to activate your account.
            </p>
          </div>
          <div *ngIf="registrationCompleted && invitation">
            <h6>
              Account Created
            </h6>
            <p>
              Your account has been created succesfully.
            </p>
            <p>
              <a [routerLink]="['/auth/login']">Log In</a>
            </p>
          </div>
          <div *ngIf="invitedEmailHasUser">
            <p>
              There has already been an account created for
              {{ invitation.email }}.
            </p>
            <p>
              <a [routerLink]="['/auth/login']">Log In</a>
            </p>
          </div>
        </div>
        <div class="card-footer">
          <a
            id="lnkUserPrivacyPolicy"
            title="Opens in a new tab"
            href="https://www.schneidergis.com/privacypolicy"
            target="_blank"
            [ngClass]="{ 'link-color': templateForPermitForm }"

            >User Privacy Policy</a
          >
          <br />
          <a
            id="lnkGDPRPrivacyPolicy"
            title="Opens in a new tab"
            href="https://www.schneidergis.com/gdprprivacynotice"
            target="_blank"
            [ngClass]="{ 'link-color': templateForPermitForm }"

            >GDPR Privacy Notice</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
